import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "item", "previous", "next"]

  connect() {
    this.update()
  }

  scroll({ params: { direction } }) {
    this.trackTarget.scrollBy({ left: direction * this.itemTarget.offsetWidth, behavior: "smooth" })
  }

  update() {
    const { scrollLeft, scrollWidth, clientWidth } = this.trackTarget

    this.previousTarget.disabled = scrollLeft <= 0
    this.nextTarget.disabled = scrollLeft + clientWidth >= scrollWidth - 1
  }
}
